export default __webpack_public_path__ + "static/media/SD-main-offerings-img.ae0c0082.png";